<template>
  <div class="return-goods">
    <div class="return-content">
      <div class="label">您的商品还在派送中，我们将尝试拦截，可能会拦截失败，您剋选择拒收，请及时关注订单状态</div>
      <div class="goods-info">
        <el-form>
          <el-form-item label="商品信息：">
            <div class="goods">
              <img src="../../assets/air.png" alt="">
              <div class="txt-box">
                <span>纠纷解决但是房价多少积分</span>
                <p><span>单价：￥4444</span>
                </p>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="类型选择：">
            <el-radio-group v-model="radio">
              <el-radio :label="3">备选项</el-radio>
              <el-radio :label="6">备选项</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="退货原因：">
            <el-select v-model="formData.reason" placeholder="请选择">
              <el-option value="商品质量有问题"></el-option>
              <el-option value="不想要了"></el-option>
              <el-option value="实际商品与所售信息不符"></el-option>
              <el-option value="商品降价"></el-option>
              <el-option value="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="退货数量：">
            <el-input-number size="small" v-model="formData.applySkuNumber"></el-input-number>
          </el-form-item>
          <el-form-item label="照片：">
            <div class="img-box">
              <el-upload
                action
                list-type="picture-card"
                :auto-upload="false"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-change="handleSubmit">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </div>
            <p>非必传，最多9张</p>
          </el-form-item>
          <el-form-item label="退款方式：">
            <span>原路返回</span>
          </el-form-item>
        </el-form>
        
        <div class="selection-box">
          <div class="tip">是否收到货？</div>
          <div class="btn-box">
            <div class="btn" :class="{active: activeBtn == 1}" @click="handelClick(1)">
              <img src="../../assets/icon/shou.png" alt="">
              <span>已收到货</span>
            </div>
            <div class="btn" :class="{active: activeBtn == 2}" @click="handelClick(2)">
              <img src="../../assets/icon/wei.png" alt="">
              <span>未收到货</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {uploadImgToQiniu} from '../../../util/publicMethod'
import {
  GetQiniuToken
} from '../../api/api'
export default {
  data(){
    return{
      activeBtn: 0,
      radio: 0,
      dialogImageUrl: '',
      dialogVisible: false,
      qiniuToken: '',
      formData: {
        orderNo: '',
        applySkuNumber: '',
        reason: '',
        productStatus: 1,
        attachUrl: ''
      }
    }
  },
  created(){
    this.getQiniuToken()
  },
  methods:{
    getQiniuToken(){
      GetQiniuToken().then((res) => {
        if (res.data.success) {
          this.qiniuToken = res.data.response;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(() => {});
    },
    handelClick(v){
      this.activeBtn = v
    },
    handleSubmit(file, fileList) {
      console.log(file, fileList);
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: this.qiniuToken,
      };
      uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          console.log(res,'44444444')
          // let itemPic;
          // if (this.goodDetailForm.BusinessPics[0]) {
          //   itemPic = {
          //     SpuPicUrl: res,
          //     IsMain: false,
          //   };
          // } else {
          //   itemPic = {
          //     SpuPicUrl: res,
          //     IsMain: true,
          //   };
          // }
          // this.goodDetailForm.BusinessPics.push(itemPic);
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.return-goods{
  padding-bottom: 40px;
  font-size: 16px;
}
.return-content{
  width: 1200px;
  margin: 0 auto;
  text-align: left;
  .label{
    background: #fef1dc;
    height: 46px;
    color: #f46e00;
    font-size: 20px;
    font-weight: bold;
    padding-left: 40px;
    line-height: 46px;
    margin-bottom: 20px;
  }
  .goods-info{
    background: #ffffff;
    border-radius: 10px;
    padding: 50px;
    .goods{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      position: relative;
      img{
        width: 90px;
        height: 90px;
      }
      .txt-box{
        margin-left: 20px;
        p{
          position: absolute;
          bottom: 0;
        }
      }
    }
    .selection-box{
      .tip{
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        margin: 20px 0;
      }
      .btn-box{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .btn{
          margin-right: 50px;
          cursor: pointer;
          border: 3px solid #f4f4f4;
          border-radius: 10px;
          width: 400px;
          height: 156px;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 44px;
            height: 44px;
          }
          span{
            font-size: 24px;
            font-weight: bold;
            color: #333333;
            margin-left: 10px;
          }
        }
        .active{
          border: 3px solid #f40000;
        }
      }
    }
  }
}
</style>